import { ROUTES } from '@/router/routeNames'

export default [
  {
    name: ROUTES.PEOPLE,
    path: 'people',
    component: () => import('./pages/RecentVisitors.vue'),
    meta: {
      title: 'People',
      description: 'View the most recently active visitors to your website.',
      rightyPrompts: [
        {
          label: 'Most engaged',
          drawerLabel: 'Show me my most engaged visitors',
          prompt: 'Show me my most engaged visitors - who has the highest engagement score based on pageviews, survey completions, and segment activity?'
        },
        {
          label: 'Ready to convert',
          drawerLabel: 'Which visitors are ready to convert?',
          prompt: 'Which visitors look ready to convert? Show me people who have seen offers, visited key pages, or shown buying signals.'
        }
      ]
    }
  },
  {
    name: ROUTES.VISITOR_DETAIL,
    path: 'people/:visitorId',
    component: () => import('./pages/VisitorDetail.vue'),
    meta: {
      title: 'Visitor Detail',
      description: 'View complete activity timeline for a specific visitor.',
      rightyPrompts: [
        {
          label: 'Analyze journey',
          drawerLabel: 'Analyze this visitor\'s journey',
          prompt: 'Analyze this visitor\'s journey through my site. What are they interested in and what can I learn from their behavior?'
        },
        {
          label: 'Next best action',
          drawerLabel: 'What should I do next with this visitor?',
          prompt: 'Based on this visitor\'s profile and behavior, what should I do next to engage them? What content or offers would be most relevant?'
        }
      ]
    }
  }
]
